// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-matches-days-admin__container {
    width: 100%;
}

.tournament-matches-days-admin__container .MuiAccordionDetails-root {
    display: flex;
    padding: 32px 0;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.tournament-matches-days-admin__container .MuiAccordionDetails-root .tournament-matches-days-admin__msg:last-of-type {
    color: var(--new-green-color);
    cursor: pointer;
}

.tournament-matches-days-admin__container .MuiAccordionDetails-root .tournament-matches-days-admin__msg:first-of-type {
    color: var(--basic-gray-color);
}

.tournament-matches-days-admin__container .MuiAccordionSummary-root {
    background: var(--new-light-gray-background-color);
    border: 1px solid var(--new-background-color);
}

.tournament-matches-days-admin__container .MuiFormControlLabel-root .MuiTypography-body1 {
    font-weight: 500;
    color: var(--primary-very-dark-color);
}

.tournament-matches-days-admin__day-options {
    position: relative;
}

.tournament-matches-days-admin__day-options__action {
    padding: 8px;
    border-radius: 8px;
    background-color: var(--white-color);
    box-shadow: var(--shadow-card-1);
    position: absolute;
    top: 42px;
    left: 14px;
    display: none;
    z-index: 100;
}

.tournament-matches-days-admin__day-options__action .baloa-names {
    color: var(--primary-very-dark-color);
    padding: 8px;
    background-color: var(--new-background-color);
    border-radius: 4px;
    min-width: 172px;
    display: block;    
}

.tournament-matches-days-admin__day-options__action.show {
    display: block;
}

.tournament-matches-days-admin__day-options .icon-options {
    font-size: 14px;
    color: var(--black-color);
    font-weight: 900;
}

.tournament-matches-days-admin__view-more {
    padding: 12px;
    cursor: pointer;
    border: 1px solid var(--new-gray-background-color);
    width: 98%;
    text-align: center;
}

.tournament-matches-days-admin__view-more.baloa-names {
    color: var(--new-green-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-matches-days-admin/TournamentMatchesDaysAdminComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kDAAkD;IAClD,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,gCAAgC;IAChC,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kDAAkD;IAClD,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".tournament-matches-days-admin__container {\n    width: 100%;\n}\n\n.tournament-matches-days-admin__container .MuiAccordionDetails-root {\n    display: flex;\n    padding: 32px 0;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.tournament-matches-days-admin__container .MuiAccordionDetails-root .tournament-matches-days-admin__msg:last-of-type {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.tournament-matches-days-admin__container .MuiAccordionDetails-root .tournament-matches-days-admin__msg:first-of-type {\n    color: var(--basic-gray-color);\n}\n\n.tournament-matches-days-admin__container .MuiAccordionSummary-root {\n    background: var(--new-light-gray-background-color);\n    border: 1px solid var(--new-background-color);\n}\n\n.tournament-matches-days-admin__container .MuiFormControlLabel-root .MuiTypography-body1 {\n    font-weight: 500;\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-matches-days-admin__day-options {\n    position: relative;\n}\n\n.tournament-matches-days-admin__day-options__action {\n    padding: 8px;\n    border-radius: 8px;\n    background-color: var(--white-color);\n    box-shadow: var(--shadow-card-1);\n    position: absolute;\n    top: 42px;\n    left: 14px;\n    display: none;\n    z-index: 100;\n}\n\n.tournament-matches-days-admin__day-options__action .baloa-names {\n    color: var(--primary-very-dark-color);\n    padding: 8px;\n    background-color: var(--new-background-color);\n    border-radius: 4px;\n    min-width: 172px;\n    display: block;    \n}\n\n.tournament-matches-days-admin__day-options__action.show {\n    display: block;\n}\n\n.tournament-matches-days-admin__day-options .icon-options {\n    font-size: 14px;\n    color: var(--black-color);\n    font-weight: 900;\n}\n\n.tournament-matches-days-admin__view-more {\n    padding: 12px;\n    cursor: pointer;\n    border: 1px solid var(--new-gray-background-color);\n    width: 98%;\n    text-align: center;\n}\n\n.tournament-matches-days-admin__view-more.baloa-names {\n    color: var(--new-green-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
